import { render, staticRenderFns } from "./sumbit.vue?vue&type=template&id=7c6df2ff&scoped=true&"
import script from "./sumbit.vue?vue&type=script&lang=js&"
export * from "./sumbit.vue?vue&type=script&lang=js&"
import style0 from "./sumbit.vue?vue&type=style&index=0&id=7c6df2ff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6df2ff",
  null
  
)

export default component.exports